import { Message } from "../../types";
import { ErrorState } from "./components/state/error/ErrorState";
import { LoadingIndicator } from "./components/LoadingIndicator";
import { MessageList } from "./components/MessageList";
import { ErrorMessage } from "./components/state/error/ErrorMessage";
import { EmptyState } from "./components/state/error/EmptyState";
import Loader from "components/Loader";
import { ArrowDown } from "lucide-react";

export const ChatContent: React.FC<{
  messagesContainerRef: React.RefObject<HTMLDivElement>;
  topSentinelRef: React.RefObject<HTMLDivElement>;
  bottomSentinelRef: React.RefObject<HTMLDivElement>;
  handleScroll: (e: React.UIEvent<HTMLDivElement>) => void;
  isLoading: boolean;
  isLoadingOlder: boolean;
  isLoadingNewer: boolean;
  loadError: string | null;
  olderError: string | null;
  newerError: string | null;
  messages: Message[];
  retryLoadInitialMessages: () => void;
  retryLoadOlderMessages: () => void;
  retryLoadNewerMessages: () => void;
  isAtBottom: boolean;
  scrollToBottom: () => void;
}> = ({
  messagesContainerRef,
  topSentinelRef,
  bottomSentinelRef,
  handleScroll,
  isLoading,
  isLoadingOlder,
  isLoadingNewer,
  loadError,
  olderError,
  newerError,
  messages,
  retryLoadInitialMessages,
  retryLoadOlderMessages,
  retryLoadNewerMessages,
  isAtBottom,
  scrollToBottom,
}) => (
  <div className="relative h-[calc(100%-70px)] pt-2">
    <div className="flex h-[calc(100%-74px)] w-full">
      <div
        ref={messagesContainerRef}
        className="chat-scrollbar w-full overflow-y-auto"
        onScroll={handleScroll}
      >
        <div className="relative max-h-max overflow-hidden pb-[30px]">
          <LoadingIndicator isLoading={isLoadingOlder} />
          <ErrorMessage error={olderError} onRetry={retryLoadOlderMessages} />
          <div ref={topSentinelRef} className="h-1"></div>

          {isLoading ? (
            <Loader txt="Loading conversation..." />
          ) : loadError ? (
            <ErrorState error={loadError} onRetry={retryLoadInitialMessages} />
          ) : messages.length === 0 ? (
            <EmptyState />
          ) : (
            <MessageList messages={messages} />
          )}

          <LoadingIndicator isLoading={isLoadingNewer} />
          <ErrorMessage error={newerError} onRetry={retryLoadNewerMessages} />
          <div ref={bottomSentinelRef} className="h-1"></div>
        </div>
        {/* Floating scroll-to-bottom button */}
        {!isAtBottom && (
          <button
            onClick={scrollToBottom}
            className="absolute bottom-20 right-4 z-50 flex items-center justify-center rounded-full bg-gray-200 p-1.5 opacity-90 shadow-lg transition-colors hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600"
            aria-label="Scroll to bottom"
            style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.10)" }}
          >
            <ArrowDown className="size-5 text-gray-600 dark:text-gray-200" />
          </button>
        )}
      </div>
    </div>
  </div>
);
